<template>
    <div class="col_y">
        <!-- TODO: ai group 로직 추가 -->
        <div class="header_wrap" :class="{ 'ai_group': isAIGroup }" v-if="!isEmpty">
            <div
                class="title"
                @mousedown.left.prevent="action_MouseDown"
                @mousemove.left.prevent="action_MouseMove"
                @mouseup.left.prevent="action_MouseUp"
                @mouseup.right.prevent="action_MouseRight"
            >
                <span class="txt" :title="title" style="width: minimumWidth">{{ title }}</span>
                <button class="rsv_col_add_btn" @click.prevent="action_AddGroup">
                    <v-icon>mdi-plus</v-icon>
                </button>
                <div class="col_resize" @mousedown.left.prevent="action_MouseDownForWidth"></div>
            </div>
            <div class="title_name">
                <DoctorTitle
                    v-for="(column, index) in columns"
                    :key="index"
                    :groups="groups"
                    :column="column"
                    :xPosition="xPosition + index"
                    :selectedAreaHelper="selectedAreaHelper"
                    :isAIGroup="isAIGroup"
                />
            </div>
        </div>
        <div class="header_wrap" style="width: 160px" v-if="isEmpty">
            <div class="title">
                <button class="rsv_col_add_btn no_fix" @click.prevent="action_AddGroup">
                    <v-icon>mdi-plus</v-icon>
                </button>
            </div>
        </div>
        <div class="body_wrap">
            <DoctorColumn
                v-for="(column, index) in columns"
                :key="index"
                :column="column"
                :xPosition="xPosition + index"
                :selectedAreaHelper="selectedAreaHelper"
                :hoverReservation="hoverReservation"
                :originalWorkRecords="originalWorkRecords"
                :originalBlocksAndColors="originalBlocksAndColors"
                @action_ReservationMouseOver="handleReservationMouseOver"
            />
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import DoctorTitle from './DoctorTitle.vue'
import DoctorColumn from './DoctorColumn.vue'

import { sheetState } from '../../../sheet-state'
import { hideCellMenu, hideGroupMenu, hideReservationMenu, showGroupMenu, showGroupSetting } from '../../../sheet-overlays'
import { sheetAxis } from '../../../sheet-axis'
import { columnWidth, startColumnResize } from './column-width'

export default {
    components: { DoctorTitle, DoctorColumn },
    props: {
        groups: Array,
        group: Object,
        index: Number,
        selectedAreaHelper: Object,
        hoverReservation: Object,
        originalWorkRecords: Array,
        originalBlocksAndColors: Array
    },
    data() {
        return {
            sheetState,
            sheetAxis,
            columnWidth
        }
    },
    computed: {
        isEmpty: function () {
            return this.group?._id == undefined;
        },
        isAIGroup: function () {
            return this.group?.isAi;
        },
        groupID: function () {
            return this.group?._id ?? ''
        },
        title: function () {
            return this.group?.title
        },
        columns: function () {
            let columns = deepCopy(this.group?.columns) ?? []
            if (columns.length == 0) {
                columns.push({ _id: undefined, groupID: { _id: this.group._id } })
            }
            return columns.sort((l, r) => {
                return l.order - r.order
            })
        },
        xPosition: function () {
            if (this.groups == undefined) {
                return 0
            }
            let groupIndex = this.groups.indexOf(this.group)
            let index = 0
            for (let i = 0; i < groupIndex; i++) {
                index += this.groups[i].columns?.length ?? 0
            }
            return index
        },
        yLength: function () {
            return this.sheetAxis.timeArray.length
        },
        wLength: function () {
            return this.group.columns.length - 1
        },
        selectedRange: function () {
            return this.selectedAreaHelper.selectedRange
        },
        startX: function () {
            return this.selectedRange.start.x > this.selectedRange.end.x ? this.selectedRange.end.x : this.selectedRange.start.x
        },
        endX: function () {
            return this.selectedRange.start.x < this.selectedRange.end.x ? this.selectedRange.end.x : this.selectedRange.start.x
        },
        selectedColumns: function () {
            let columns = []
            for (let i = 0; i < this.groups.length; i++) {
                columns = columns.concat(this.groups[i].columns.filter((c) => c.isSelected))
            }
            return columns
        },
        minimumWidth: function() {
            return this.$store.state.V2ReservationCellConfig.defaultMinimumWidth
        }
    },
    methods: {
        handleReservationMouseOver(reservation, hoverEvent, isShow) {
            this.$emit('action_ReservationMouseOver', reservation, hoverEvent, isShow)
        },

        // MARK: - Actions
        action_AddGroup() {
            let index = this.group.order + 1
            if (this.isEmpty) {
                index = 0
            }
            showGroupSetting({ order: index })
        },
        action_MouseDown() {
            if (this.columnWidth.isResizing == true) {
                return
            }
            hideCellMenu()
            hideReservationMenu()
            this.selectedAreaHelper.setType(this.selectedAreaHelper.Type.group)
            this.selectedAreaHelper.setStartPoint(this.xPosition, 0)
            this.selectedAreaHelper.setEndPoint(this.xPosition + this.wLength, this.yLength - 1)
        },
        action_MouseMove() {
            if (this.columnWidth.isResizing == true) {
                return
            }
            if (this.selectedAreaHelper == undefined) {
                return
            }
            if (this.selectedAreaHelper.startPoint.x == undefined) {
                return
            }
            if (this.selectedAreaHelper.currentType != this.selectedAreaHelper.Type.group) {
                return
            }
            if (this.selectedAreaHelper.startPoint.x > this.xPosition) {
                // calc start group x right side position
                let comp = this
                let isLastIndex = function (xPosition) {
                    let sum = 0
                    for (let i = 0; i < comp.groups.length; i++) {
                        let group = comp.groups[i]
                        sum += group?.columns?.length ?? 0
                        if (sum == xPosition + 1) {
                            return true
                        }
                        if (sum > xPosition + 1) {
                            break
                        }
                    }
                    return false
                }
                let getStartGroup = function (xPosition) {
                    let index = 0
                    for (let i = 0; i < comp.groups.length; i++) {
                        let group = comp.groups[i]
                        if (group.isSelected == false) {
                            continue
                        }
                        index += group.columns?.length ?? 0
                        if (index > xPosition) {
                            break
                        }
                    }
                    return index - 1
                }
                let _isLastindex = isLastIndex(this.selectedAreaHelper.startPoint.x)
                if (_isLastindex == false) {
                    let startGroupIndex = getStartGroup(this.selectedAreaHelper.startPoint.x)
                    this.selectedAreaHelper.setStartPoint(startGroupIndex, 0)
                }
                this.selectedAreaHelper.setEndPoint(this.xPosition, this.yLength - 1)
            } else {
                this.selectedAreaHelper.setEndPoint(this.xPosition + this.wLength, this.yLength - 1)
            }
            let start = this.selectedAreaHelper.endPoint
            let end = this.selectedAreaHelper.startPoint
            this.selectedAreaHelper.setSelectedRange(start.x, start.y, end.x, end.y)
        },
        action_MouseUp() {
            if (this.columnWidth.isResizing == true) {
                return
            }
            if (this.selectedAreaHelper.currentType != this.selectedAreaHelper.Type.group) {
                return
            }
            let start = this.selectedAreaHelper.startPoint
            let end = this.selectedAreaHelper.endPoint
            if (this.selectedAreaHelper.currentType == this.selectedAreaHelper.Type.column) {
                let start = this.selectedAreaHelper.endPoint
                let end = this.selectedAreaHelper.startPoint
                this.selectedAreaHelper.setSelectedRange(end.x, start.y, start.x, end.y)
            } else {
                this.selectedAreaHelper.setSelectedRange(start.x, start.y, end.x, end.y)
            }
            this.selectedAreaHelper.clearStartEndPoint()
        },
        action_MouseRight(e) {
            if (this.group._id == undefined) {
                hideGroupMenu()
                return
            }
            this.action_MouseDown()
            this.action_MouseUp()
            let position = this.getMousePosition(e)
            showGroupMenu(position, this.group)
        },
        getMousePosition(e) {
            let sheetRect = this.sheetState.sheetElement.getBoundingClientRect()
            let scrollRect = this.sheetState.sheetScrollElement
            let x = e.clientX - sheetRect.x + scrollRect.scrollLeft
            let y = e.clientY - sheetRect.y + scrollRect.scrollTop
            return { x: x, y: y }
        },

        // MARK: - Listeners
        action_MouseDownForWidth(e) {
            let last = this.group.columns.filter((c) => c.isSelected).at(-1)
            if (this.selectedAreaHelper.isColumnGroupSelection == true) {
                let currentLast = this.group.columns.filter((c) => c.isSelected).at(-1)
                let target = this.selectedColumns.find((c) => c._id == currentLast._id)
                let xPosition = this.selectedColumns.indexOf(target)
                if (this.startX > xPosition || this.endX < xPosition) {
                    this.selectedAreaHelper.clearSelectedRange()
                }
            }
            startColumnResize(e, last._id, { areaHelper: this.selectedAreaHelper, groups: this.groups })
        },
    }
}
</script>

<style scoped>
ellipse {
    display: inline-block;
    text-overflow: ellipsis;
}

/* AI 그룹 스타일 */
.header_wrap.ai_group .title {
    background-color: #F5F7FF;
}

.header_wrap.ai_group .title .txt {
    color: #1F8FE5;
}
</style>
